<template>
  <div>
    <el-dialog title="添加课程"
               :visible.sync="dialogVisible"
               v-dialogDrag
               :close-on-click-modal="false"
               :append-to-body="true"
               width="500px"
               :before-close="handleClose">
      <el-form :model="form"
               :rules="rules"
               ref="formRef"
               label-width="90px">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="课程标题"
                          prop="title">
              <el-input placeholder="请输入"
                        v-model="form.title"
                        style="width:100%" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="课程副标题">
              <el-input placeholder="请输入"
                        v-model="form.subtitle"
                        style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="教学班"
                          prop="class_id">
              <el-select v-model="form.class_id"
                         style="width:100%"
                         filterable
                         @change="getSubject"
                         placeholder="请选择">
                <el-option v-for="item in classList"
                           :key="item.id"
                           :label="item.class_name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="科目"
                          prop="special_class_subject_id">
              <el-select v-model="form.special_class_subject_id"
                         style="width:100%"
                         @change="getTeacherList"
                         placeholder="请选择">
                <el-option v-for="item in subjectList"
                           :key="item.special_class_subject_id"
                           :label="item.subject_name"
                           :value="item.special_class_subject_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="教师"
                          prop="edu_user_id">
              <el-select v-model="form.edu_user_id"
                         style="width:100%"
                         filterable
                         placeholder="请选择">
                <el-option v-for="item in teacherList"
                           :key="item.edu_user_id"
                           :label="item.edu_user_name"
                           :value="item.edu_user_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="课室"
                          prop="class_room_id">
              <el-select v-model="form.class_room_id"
                         style="width:100%"
                         filterable
                         placeholder="请选择">
                <el-option v-for="item in classRoomList"
                           :key="item.id"
                           :label="item.room_name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="开始时间"
                          prop="start_time">
              <el-date-picker v-model="form.start_time"
                              style="width:100%"
                              @focus="$forbid"
                              type="datetime"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="开始时间" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="截止时间"
                          prop="end_time">
              <el-date-picker v-model="form.end_time"
                              style="width:100%"
                              @focus="$forbid"
                              type="datetime"
                              default-time="23:59:59"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              placeholder="截止时间" />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="公告">
              <el-input placeholder="公告"
                        v-model="form.notice"
                        type="textarea"
                        :rows="4"
                        style="width:100%" />
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="save">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisible: false,
      form: {},
      gradeList: [],
      classRoomList: [],
      teacherList: [],
      classList: [],
      subjectList: [],
      rules: {
        title: [
          { required: true, message: '请输入', trigger: 'change' },
        ],
        class_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        edu_user_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        class_room_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        start_time: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        end_time: [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        special_class_subject_id: [
          { required: true, message: '请选择', trigger: 'change' },
        ],

      },
    }
  },
  computed: {
  },
  mounted () {
    this.getClassRoom()
  },
  methods: {
    getSubject () {
      this.form.special_class_subject_id = ''
      this.subjectList = []
      if (!this.form.class_id) return
      this.$http({
        url: '/api/v1/public/class_grade_subject',
        method: 'get',
        // params: {
        //   class_id: this.form.class_id
        // }
      }).then(res => {
        this.subjectList = res.data
      })
    },
    getClassRoom () {
      this.$http({
        url: '/api/v1/special/room_lst',
        method: 'get',
      }).then(res => {
        this.classRoomList = res.data.list
      })
      this.$http({
        url: '/api/v1/special/class_lst',
        method: 'get',
        params: {
          page: 1,
          limit: 10000
        }
      }).then(res => {
        this.classList = res.data.list
      })
    },
    getTeacherList (id) {
      this.form.edu_user_id = ''
      this.teacherList = []
      if (!id) return
      this.$http({
        url: '/api/v1/public/class_subject_tc',
        method: 'get',
        params: {
          special_class_subject_id: id
        }
      }).then(res => {
        this.teacherList = res.data
      })
    },
    handleClose () {
      this.$refs.formRef.resetFields()
      this.dialogVisible = false
    },
    save () {
      this.$refs.formRef.validate(val => {

        let form = JSON.parse(JSON.stringify(this.form))
        delete form.class_id
        if (!val) return
        this.$http({
          url: '/api/v1/special/schedule_add',
          method: 'post',
          data: form
        }).then(res => {
          this.$notify({
            title: '提示',
            message: '修改成功!',
            type: 'success'
          });
          this.$parent.refresh()
          this.handleClose()
        })
      })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  font-size: 20px;
  font-weight: bold;
  color: black;
  text-align: center;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  background: #cccccc;
  border-radius: 50%;
  padding: 4px;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
.toopic {
  font-size: 12px;
  line-height: 14px;
  span {
    margin-left: -12px;
    display: inline-block;
    width: 100%;
    width: 305px;
    color: #ff8383;
    transform: scale(0.9);
  }
}

::v-deep .el-dialog {
  border-radius: 15px;
}
.el-tabs {
  margin-left: 20px;
}
::v-deep .el-tabs__nav-wrap::after {
  background: none;
}
.warp {
  display: flex;
  margin-top: 20px;
  div {
    &:nth-child(1) {
      flex: 1;
      margin-left: 8px;
    }
    &:nth-child(2) {
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>